import React, { FC } from "react";

// i18n
import messages from "./messages";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";

// UI
import { Box } from "@UI/Components/Box/Box";

// hooks
import { useDataMutation } from "@Libs/DataLayer/hooks/useDataMutation";

// types
import { IOutlets } from "@Libs/Transclusion/types/outlets";
import { PaymentMethodType } from "@modules/PaymentProcessing/types";
import { PaymentMethodForm } from "@modules/PaymentProcessing/Components/PaymentMethodForm/PaymentMethodForm";
import { ResponsiveFixedButton } from "@UI/Components/ResponsiveFixedButton/ResponsiveFixedButton";

type Props = Omit<
  IOutlets["configure-preferred-payment-method.body"]["props"],
  "paymentMethod" | "basket"
> & { children?: React.ReactNode };

export const ConfigureBancontact: FC<Props> = ({ onBack, onSubmit, children }) => {
  const saveBancontactMethodMutation = useDataMutation(() =>
    onSubmit(
      {
        provider: "stripe",
        paymentMethod: PaymentMethodType.BANCONTACT,
      },
      {
        onError: async (error) => {
          console.error(error);
        },
        onSuccess: async () => {
          console.log("success");
        },
      }
    )
  );

  return (
    <PaymentMethodForm>
      <PaymentMethodForm.Header
        onChangeClick={onBack}
        paymentMethod={PaymentMethodType.BANCONTACT}
      >
        <FormattedMessage {...messages.bancontact} />
      </PaymentMethodForm.Header>

      <PaymentMethodForm.Body>
        <Box>
          <Box mb={5}>{children}</Box>
          <ResponsiveFixedButton
            data-testid="submit-bancontact-button"
            isLoading={saveBancontactMethodMutation.isLoading}
            h={12}
            width="full"
            colorScheme="seaGreen"
            onClick={() => saveBancontactMethodMutation.mutate()}
            isDisabled={saveBancontactMethodMutation.isLoading}
          >
            <FormattedMessage {...messages.submit} />
          </ResponsiveFixedButton>
        </Box>
      </PaymentMethodForm.Body>
    </PaymentMethodForm>
  );
};
